import { AnswerType } from '../services/types';
export const AnswerTypeEnum = {
    None: AnswerType[0],
    Yes: AnswerType[1],
    No: AnswerType[2],
    Abstain: AnswerType[3],
};
